/**
 * Chat widget message constants
 */

export const WELCOME_MESSAGE = "👋 Good day! I'm Nia, your dedicated support. I'm here to help you explore training, certifications, and services. What would you like to do today?";

